function showNext(next_fs,current_fs){
  //Add Class Active
  $("#progressbar li").eq($("fieldset").index(next_fs)).addClass("active");

  //show the next fieldset
  next_fs.show();
  //hide the current fieldset with style
  current_fs.animate(
    { opacity: 0 },
    {
      step: function (now) {
        // for making fielset appear animation
        opacity = 1 - now;

        current_fs.css({
          display: "none",
          position: "relative",
        });
        next_fs.css({ opacity: opacity });
      },
      duration: 600,
    }
  );
}

function validateSetUpInputOnKeyPress(el){
  el.keyup(function(e) {
    if (isEmpty($(e.target).val())){
      $(e.target).addClass("is-invalid form-control")
    }else{
      $(e.target).removeClass("is-invalid form-control")
    }
  });
}

function validateOnNextClick(el){
  $(el).children('.set-up-required').each(function(){
    if (isEmpty($(this).val())){
      $(this).addClass("is-invalid form-control")
    }
  })
}

$(document).ready(function () {
  var current_fs, next_fs, previous_fs; //fieldsets
  var opacity;

  $('.set-up-required').each(function(){
    validateSetUpInputOnKeyPress($(this))
  })

  $(".next").click(function (e) {
    current_fs = $(this).parent();
    next_fs = $(this).parent().next();
    var firstName = $('#set-up-first-name').val();
    var lastName = $('#set-up-last-name').val();
    var phone = $('#set-up-phone').val();
    var orgName = $('#set-up-organization-name').val();
    var orgSubdomain = $('#set-up-organization-subdomain').val();
    var orgLocation = $('#set-up-organization-location').val();
    var orgEmail = $('#set-up-organization-email').val();
    var orgPhone = $('#set-up-organization-phone').val();
    var planName = $('#subscription-plan-name').val();
    var paymentPlan = $('#subscription-payment-plan').val();
    const nextButton = e.target;
    const fieldset = $(nextButton).closest('fieldset');
    const formCard = $(fieldset).children('.form-card')[0];

    if($('#set-up-first-name').is(':visible')){
      if((isEmpty(firstName) || isEmpty(lastName) )){
        validateOnNextClick(formCard)
      }else{
        showNext(next_fs,current_fs)
        $('#review-name').html(firstName + ' ' + lastName);
        $('#review-phone').html(phone);
      }
    }

    if($('#set-up-organization-name').is(':visible')){
      if(isEmpty(orgName) || isEmpty(orgSubdomain) || isEmpty(orgLocation) || isEmpty(orgEmail)){
        validateOnNextClick(formCard)
      }else{
        showNext(next_fs,current_fs)
        $('#review-organization-name').html(orgName);
        $('#review-organization-subdomain').html(orgSubdomain);
        $('#review-organization-location').html(orgLocation);
        $('#review-organization-email').html(orgEmail);
        $('#review-organization-phone').html(orgPhone);
      }
    }

    if($('#pricing-tabs').is(':visible')){
      if(isEmpty(planName) || isEmpty(paymentPlan)){
        toastNotification('error', $(nextButton).data('error'))
      }else{
        showNext(next_fs,current_fs)
        const subscriptions = $('#msform').data('subscriptions')
        let amount = subscriptions[planName][paymentPlan]
        let text = numberWithCommas(amount) + ' ' + 'paid per month'

        if(paymentPlan == 'yearly'){
          let yearAmount = amount * 12
          text = numberWithCommas(yearAmount) + ' ' + 'paid once per year'
        }
        
        $('#review-subscription-plan').html(planName + ' - ' + paymentPlan)
        $('#review-subscription-details').html(text)
      }
    }
  });

  $(".previous").click(function () {
    current_fs = $(this).parent();
    previous_fs = $(this).parent().prev();

    //Remove class active
    $("#progressbar li")
      .eq($("fieldset").index(current_fs))
      .removeClass("active");

    //show the previous fieldset
    previous_fs.show();

    //hide the current fieldset with style
    current_fs.animate(
      { opacity: 0 },
      {
        step: function (now) {
          // for making fielset appear animation
          opacity = 1 - now;

          current_fs.css({
            display: "none",
            position: "relative",
          });
          previous_fs.css({ opacity: opacity });
        },
        duration: 600,
      }
    );
  });

  $(".radio-group .radio").click(function () {
    $(this).parent().find(".radio").removeClass("selected");
    $(this).addClass("selected");
  });

  

  $("#msform").submit(function(e){
    e.preventDefault();

    var details = {
      first_name: $('#set-up-first-name').val(),
      last_name: $('#set-up-last-name').val(),
      phone: $('#set-up-phone').val(),
      org_name: $('#set-up-organization-name').val(),
      org_subdomain: $('#set-up-organization-subdomain').val(),
      org_location: $('#set-up-organization-location').val(),
      org_email: $('#set-up-organization-email').val(),
      org_phone: $('#set-up-organization-phone').val(),
      plan_name: $('#subscription-plan-name').val(),
      payment_plan: $('#subscription-payment-plan').val()
    }

    toastNotification('info', 'please wait while we set up your details, you will be redirected shortly');

    $.ajax({
      type: 'POST' ,
      url: $('#msform').attr('action'),
      headers: {
        'X-CSRF-Token': csrfToken()
      },
      data: { ...details },
      dataType: "json",
      success: function (data) {
        if (data.success == true ){
          window.location.replace(data.redirect_url);
          toastNotification('success', data.message);
        }else{
          toastNotification('error', data.message);
        }
        console.log(data);
      },
      error: function (data) {
          console.log('An error occurred.');
          console.log(data);
      },
  });
});

  $('.select-plan').click(function (e){
    let paymentPlan = $(e.target).data('payment-plan');
    let planName = $(e.target).data('plan-name');

    $('#subscription-plan-name').val(planName);
    $('#subscription-payment-plan').val(paymentPlan);

    $('.plan').removeClass("featured bg-primary");
    $('.select-plan').removeClass("btn-secondary btn-primary");
    $('.select-plan').addClass("btn-primary");
    $(e.target).addClass("btn-secondary");
    $(e.target).removeClass("btn-primary");
    $(e.target).closest('.plan').addClass("featured bg-primary");
  })
});
